export const actions = {
  ADD: 'MESSAGES_NOTIFICATION_ADD',
  POP: 'MESSAGES_NOTIFICATION_POP',
  CLEAR: 'MESSAGES_NOTIFICATION_CLEAR',
  REMOVE: 'MESSAGES_NOTIFICATION_REMOVE',
};

export function add(notification) {
  return {
    type: actions.ADD,
    value: notification,
  };
}

/**
 * Removes the most recent notification
 * Note - does *not* return this value
 * @returns {{type: string}}
 */
export function pop() {
  return {
    type: actions.POP,
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}

export function remove(index) {
  return {
    type: actions.REMOVE,
    value: index,
  };
}



// WEBPACK FOOTER //
// ./src/store/messages/notifications/actions.js